import { render, staticRenderFns } from "./ShopCreate.vue?vue&type=template&id=556ad801"
import script from "./ShopCreate.vue?vue&type=script&lang=js"
export * from "./ShopCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports